import axios from '@axios'

const route = 'manager_accommodation'
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    storeOutstanding(context, payload) {
      return axios.post(`${route}/move_outstanding`, payload)
    },
    getOutsatnding(context, { itemsPerPage, page, filter }) {
      return axios.get(`${route}/outstanding?page=${page}&items_per_page=${itemsPerPage}&status=${filter.status}&date=${filter.date}`, filter)
    },
    updateOutstanding(context, room) {
      return axios.post(`${route}/outstanding/update/${room.id}`, room)
    },
    exportAccommodationPdf(context, room) {
      return axios.get(`${route}/outstanding/export_accommodation_pdf/${room.id}`, { responseType: 'blob' })
    },
    exportConsumptionPdf(context, room) {
      return axios.get(`${route}/outstanding/export_consumption_pdf/${room.id}`, { responseType: 'blob' })
    },
    storeTransfRoom(context, transf) {
      return axios.post(`${route}/outstanding/store_transf_room/${transf.accommodation_id}`, { room_id: transf.room_id, outstanding_id: transf.outstanding_id })
    },
    storeTransItens(context, transf) {
      return axios.post(`${route}/outstanding/store_trans_itens`, transf)
    },
    createOutstanding(context, request) {
      return axios.post(`${route}/create_outstanding`, request)
    },
    exportOutstandingPdf(context, request) {
      return axios.get(`${route}/outstanding/exportPdf`, {
        params: request,
        responseType: 'blob',
      })
    },
  },
}
